module.exports = __webpack_public_path__ + "img/rami.8d8d8856.jpg";